module.exports = ".editorForm{margin-top:3%}\n"